import React, { createContext, useState, ReactNode, useEffect, useMemo, useContext } from 'react';
import ProgramType from 'src/types/programType';
import NavigationHelper from '@components/agile/utils/URLParametersUtils';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '@store/hooks';
import { updateProgram } from '@store/slices/programSlice';

interface AppContextValue {
  programType: ProgramType;
}

export const AppContext = createContext<AppContextValue>({
  programType: ProgramType.AmazonFresh,
});

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [programType, setProgramType] = useState<ProgramType>(ProgramType.AmazonFresh);
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const newProgramType = NavigationHelper.parseProgramTypeFromPath(location.pathname);
    if (newProgramType) {
      setProgramType(newProgramType);
      dispatch(updateProgram(newProgramType));
    }
  }, [dispatch, location.pathname]);
  // Memoize the context value to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      programType,
    }),
    [programType],
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
